import React from 'react';
import { Form, Input, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import PET_CONFIG from 'config/pet.config';
import { addInternalNote } from 'store/root/actions/messages';

const { Title } = Typography;
const { TextArea } = Input;

export const TAB_NOTES_CREATE_FORM = 'tab-notes__create-form';
const NEW_NOTE_MESSAGE = 'newNoteMessage';

const CreateNoteForm = () => {
  const dispatch = useDispatch();
  const listing = useSelector((state) => ({
    id: state.listingReducer.data.id,
  }));

  const onFinish = (values) => {
    const message = values[NEW_NOTE_MESSAGE];
    const note = {
      listingIds: [listing.id],
      note: {
        message,
        noteTypeId: PET_CONFIG.noteTypeId.internal,
      },
    };
    dispatch(addInternalNote(note));
  };

  const textAreaConfiguration = [
    { required: true, message: 'Please write internal note.' },
  ];

  return (
    <Form id={TAB_NOTES_CREATE_FORM} layout="vertical" onFinish={onFinish}>
      <Title level={4}>New note</Title>
      <Form.Item
        label="Create new internal note"
        name={NEW_NOTE_MESSAGE}
        rules={textAreaConfiguration}
      >
        <TextArea rows={6} />
      </Form.Item>
    </Form>
  );
};

export default CreateNoteForm;
